import React from "react";
import SingleProject from "./SingleProject";

function ProjectList({ projectState, filteredData }) {
  return (
    <div className="flex flex-col pb-2 overflow-auto ">
      {filteredData?.map((project) => (
        <SingleProject
          key={project.id}
          project={project}
          projectState={projectState}
        />
      ))}
    </div>
  );
}

export default ProjectList;
